/** Removing data attribute loading for initial zoom postion for first image */
document.querySelector('product-modal .media-first-image img').removeAttribute('loading');

/** Removing  other pdp badges from modal except first image modal*/
const badges = document.querySelectorAll('product-modal .media-first-image .pdp-badges');
badges.forEach((item, index) => {
    if (index !== 0) {
        item.remove();
    }
});